import { Injectable } from '@angular/core';
import { UrlBuilder } from '../../../shared/crud/api/url-builder';

@Injectable()
export class AdminUrlBuilder extends UrlBuilder {

  getBaseUrl(): string {
    return '/admin';
  }
}
